import { BaseRequest } from '@/network/requests/BaseRequest'
import { rule_Info } from '@/interfaces/rule_Info'
import { stringToBlob } from '@/util/stringToPlainTextBlob'

export const ruleInfoRequest = BaseRequest.build<rule_Info>('rule_info')

/**
 * 上传 xml 内容到 rule_info.files，并保存至 rule_info
 * @param content 文件内容
 * @param fileName 文件名
 * @param jtId 机台id
 * @param existFileId 已有文件Id，以供删除用。
 */
export const uploadRuleInfoXml = async (content: string, name: string, jtId: string, fileId?: string | undefined) => {
	const contentType = 'text/xml'
	const blob = stringToBlob(content, name, contentType)

	//上传文件。
	var responseFileId = await ruleInfoRequest.uploadFile(blob, contentType, fileId)

	console.log('上传文件结果', responseFileId)

	//如果传入的文件Id为空，则不更新规则信息。
	if (!fileId) {
		//上传规则。
		return ruleInfoRequest.upload({
			rule_info_file_id: responseFileId,
			jt_id: jtId,
			updated: 0,
			name,
		})
	}
}

/**
 * 删除缺陷等级参数配置。
 * @param id
 * @param fileId
 */
export const deleteRuleInfo = (id, fileId) => {
	//先删除记录。
	var p1 = ruleInfoRequest.deleteById(id)
	//再删除文件。
	var p2 = ruleInfoRequest.deleteFileById(fileId)

	return Promise.all([p1, p2])
}

/**
 * 根据 rule_info_file_id 来获取文件内容
 * @param ruleInfoFileId
 */
export const getRuleInfoByFileId = (ruleInfoFileId: string) => {
	return ruleInfoRequest.getFileContentById(ruleInfoFileId)
}
export const EditFileFromContent = async (fileId: string, name: string, existFileId?: string | undefined) => {
	return ruleInfoRequest.modifyById(fileId, { name: name })
}
